import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';

export type ReadPainelGerencialMiniDto = {
  id: number;
  nome: string;
  url: string;
  ordem: number;
};

export type ReadPainelGerencialMeuDto = {
  id: number;
  nome: string;
  descricao?: string | null;
  areaResponsavel: string;
  url: string;
  minis?: ReadPainelGerencialMiniDto[];
};

export type ReadPainelGerencialUsuarioDto = {
  id: number;
  username?: string;
  nome?: string;
};

export type ReadPainelGerencialDto = {
  id: number;
  nome: string;
  descricao?: string | null;
  areaResponsavel: string;
  url: string;
  ativo: boolean;
  minis?: ReadPainelGerencialMiniDto[];
  usuarios?: ReadPainelGerencialUsuarioDto[];
  editadoPor?: { id: number; username?: string; nome?: string };
  editadoEm?: string;
};

export type PainelGerencialMiniDto = {
  nome: string;
  url: string;
  ordem?: number;
};

export type CreatePainelGerencialDto = {
  nome: string;
  descricao?: string | null;
  areaResponsavel: string;
  url: string;
  ativo?: boolean;
  minis?: PainelGerencialMiniDto[];
  usuarioIds?: number[];
};

export type UpdatePainelGerencialDto = Partial<CreatePainelGerencialDto>;

export async function GetMeusPaineisGerenciais() {
  return api
    .get<ReadPainelGerencialMeuDto[]>(Endpoints.PAINEL_GERENCIAL + '/meus')
    .then((response) => response.data)
    .catch((error) => {
      throw ValidateAxiosError(error, 'Falha ao listar seus painéis gerenciais.');
    });
}

export async function GetPaineisGerenciais(
  skip: number,
  take: number,
  where?: string,
) {
  return api
    .get(Endpoints.PAINEL_GERENCIAL, {
      params: { skip, take, where: where || undefined },
    })
    .then((response) => GetApiReturn<ReadPainelGerencialDto>(response.data as Array<ReadPainelGerencialDto>))
    .catch((error) => {
      ValidateAxiosError<ReadPainelGerencialDto>(error, 'Falha ao listar painéis gerenciais.');
      return GetApiReturnError<ReadPainelGerencialDto>();
    });
}

export async function GetPainelGerencial(id: number) {
  return api
    .get<ReadPainelGerencialDto>(Endpoints.PAINEL_GERENCIAL + '/' + id)
    .then((response) => response.data)
    .catch((error) => {
      throw ValidateAxiosError(error, 'Falha ao buscar o painel gerencial.');
    });
}

export async function CreatePainelGerencial(dto: CreatePainelGerencialDto) {
  return api
    .post<number>(Endpoints.PAINEL_GERENCIAL, dto)
    .then((response) => response.data)
    .catch((error) => {
      throw ValidateAxiosError(error, 'Falha ao cadastrar o painel gerencial.');
    });
}

export async function UpdatePainelGerencial(id: number, dto: UpdatePainelGerencialDto) {
  return api
    .put(Endpoints.PAINEL_GERENCIAL + '/' + id, dto)
    .then(() => undefined)
    .catch((error) => {
      throw ValidateAxiosError(error, 'Falha ao atualizar o painel gerencial.');
    });
}

export async function DeletePainelGerencial(id: number) {
  return api
    .delete(Endpoints.PAINEL_GERENCIAL + '/' + id)
    .then(() => undefined)
    .catch((error) => {
      throw ValidateAxiosError(error, 'Falha ao remover o painel gerencial.');
    });
}
